<template>
  <v-dialog
    persistent
    transition="scale-transition"
    :max-width="$vuetify.breakpoint.xsOnly ? '90%' : '300'"
    v-model="this._props.component.dialog_delete"
  >
    <v-card outlined>
      <v-card-title class="text-subtitle-1 pa-3">
        Deseja retirar este produto?
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions
        class="pa-3"
        :style="$vuetify.breakpoint.xsOnly
          ? 'flex-direction: column; gap: 8px;'
          : 'justify-content: flex-end; gap: 8px;'"
      >
        <v-btn
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="red darken-4 white--text"
          @click="disableDialog"
        >Cancelar</v-btn>
        <v-btn
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="success"
          @click="component.confirm_delete()"
        >Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { component: Object },
  methods: {
    disableDialog() {
      this._props.component.dialog_delete = !this._props.component.dialog_delete;
    },
  },
};
</script>
